module.exports = __webpack_public_path__ + "img/filecoin.dbea23c9.png";